import Rest from '../Rest'

export default class CountryService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/countries'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
